// Monarch theme JS — cart drawer, color filter, PDP, quick-add, guide tabs
(function(){
  const $ = (s, p) => (p||document).querySelector(s);
  const $$ = (s, p) => [...(p||document).querySelectorAll(s)];
  const money = (cents) => 'kr ' + (cents/100).toLocaleString('nb-NO',{minimumFractionDigits:2});

  // Cart drawer ---------------------------------------------
  const drawer = $('[data-cart-drawer]');
  let backdrop = $('.cart-backdrop');
  if(!backdrop){ backdrop = document.createElement('div'); backdrop.className='cart-backdrop'; document.body.appendChild(backdrop); }

  function openCart(){ if(!drawer) return; drawer.classList.add('open'); backdrop.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeCart(){ if(!drawer) return; drawer.classList.remove('open'); backdrop.classList.remove('open'); document.body.style.overflow=''; }

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-cart-toggle]');
    if(t){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-backdrop')) closeCart();
  });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeCart(); });

  async function refreshCart(){
    try{
      const r = await fetch('/?section_id=cart-drawer-frag', {});
      // Fallback: just reload to update
      const cart = await (await fetch('/cart.js')).json();
      const countEl = $('[data-cart-count]'); const countTextEl = $('[data-cart-count-text]');
      if(countEl){ countEl.textContent = cart.item_count; countEl.toggleAttribute('hidden', cart.item_count === 0); }
      if(countTextEl) countTextEl.textContent = cart.item_count;
      // Reload drawer body via the page: simplest reliable path on a Shopify section
      const html = await (await fetch(window.location.pathname + (window.location.search || ''))).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      if(fresh && drawer){ drawer.innerHTML = fresh.innerHTML; }
    }catch(err){ console.warn('cart refresh failed', err); }
  }

  // Quick add (cards)
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-quick-add]');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    const id = btn.getAttribute('data-variant-id');
    if(!id) return;
    btn.textContent = 'Legger til...';
    try{
      await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id, quantity:1 })});
      await refreshCart();
      openCart();
      btn.innerHTML = 'Lagt til ✦';
      setTimeout(() => { btn.innerHTML = 'Legg i kurv <span style="color:var(--gold)">+</span>'; }, 1400);
    } catch(err){ btn.textContent = 'Feil — prøv igjen'; }
  });

  // PDP add form
  const addForm = $('[data-add-form]');
  if(addForm){
    addForm.addEventListener('submit', async e => {
      e.preventDefault();
      const submit = addForm.querySelector('button[type=submit]');
      const original = submit.innerHTML;
      submit.innerHTML = 'Legger til...';
      const fd = new FormData(addForm);
      const body = {}; fd.forEach((v,k) => body[k] = v);
      try{
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body) });
        await refreshCart();
        openCart();
        submit.innerHTML = 'Lagt til ✦';
        setTimeout(() => submit.innerHTML = original, 1400);
      }catch(err){ submit.innerHTML = 'Feil — prøv igjen'; }
    });

    // Qty
    const qtyInput = addForm.querySelector('[data-qty-input]');
    addForm.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => {
      const d = parseInt(b.getAttribute('data-qty'),10);
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1',10) + d);
    }));
  }

  // Filter (color family)
  $$('[data-filter-bar]').forEach(bar => {
    bar.addEventListener('click', e => {
      const btn = e.target.closest('.pill'); if(!btn) return;
      bar.querySelectorAll('.pill').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const f = btn.getAttribute('data-filter');
      const grid = bar.parentElement.querySelector('[data-grid]') || document.querySelector('[data-grid]');
      if(!grid) return;
      grid.querySelectorAll('.card').forEach(c => {
        c.style.display = (f === 'all' || c.getAttribute('data-cat') === f) ? '' : 'none';
      });
    });
  });

  // PDP gallery thumbs
  $$('.pdp-thumb').forEach(t => {
    t.addEventListener('click', () => {
      $$('.pdp-thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const main = $('[data-pdp-main]');
      if(main) main.src = t.getAttribute('data-thumb');
    });
  });

  // Guide tabs
  const tabs = $('[data-guide-tabs]');
  if(tabs){
    tabs.addEventListener('click', e => {
      const b = e.target.closest('[data-tab]'); if(!b) return;
      const i = b.getAttribute('data-tab');
      tabs.querySelectorAll('.pill').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      $$('[data-pane]').forEach(p => p.classList.toggle('active', p.getAttribute('data-pane') === i));
    });
  }
})();
